export { default as FixedTypeCoverage } from "./FixedTypeCoverage";
export { default as PriceListTypeCoverage } from "./PriceListTypeCoverage";
export { default as FormulaTypeCoverage } from "./FormulaTypeCoverage";
export { default as RenderCoverages } from "./RenderCoverages";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/index.js